export function buildDeleteConcludedCohortConfirmMessage(label: string): string {
  return [
    `Permanently delete "${label}"?`,
    "",
    "This removes all roster data, lesson progress, quiz scores, submissions, join codes, and activity history for this cohort.",
    "Your course template is not affected.",
    "",
    "This cannot be undone.",
  ].join("\n");
}
